import { createContext, useState, useContext, useEffect, useCallback } from "react";
import PropTypes from "prop-types";

import { useUserData } from "./userContext";
import { useKeikkaData } from "./KeikkaDataContext";

import { tarjous_fetchById, tarjous_fetchList_byAsiakas } from "src/data/tarjous/TarjousFunctions";

export const TarjousContext = createContext();

export const TarjousProvider = ({ children }) => {
  const { token, userAsiakas } = useUserData();
  const { keikkaData, laskuttajaAsiakas, maksajaAsiakas } = useKeikkaData();
  const [tarjousList, setTarjousList] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [selectedTarjous, setSelectedTarjous] = useState(null);

  const laskuttajaAsiakasId = laskuttajaAsiakas?.asiakasId;
  const maksajaAsiakasId = maksajaAsiakas?.asiakasId;
  const tyomaaId = keikkaData?.tyomaa?.tyomaaId;

  useEffect(() => {
    if (maksajaAsiakasId === 0 && tyomaaId === 0 && laskuttajaAsiakasId > 0 && token) {
      // Ei tarjouksia
      setIsLoaded(true);
    }
    if (!laskuttajaAsiakasId || !maksajaAsiakasId || !tyomaaId || !token) return;
    const _getTarjousList = async () => {
      setIsLoaded(false);
      let _tarjousList = await getTarjousList();
      doSetTarjousList(_tarjousList);
      setIsLoaded(true);
    };
    _getTarjousList();
  }, [laskuttajaAsiakasId, maksajaAsiakasId, tyomaaId]);

  const reloadTarjousList = async () => {
    let _tarjousList = await getTarjousList();
    doSetTarjousList(_tarjousList);
  };
  const getTarjousList = async () => {
    let _tarjousList = [];
    const tarjousListResult = await tarjous_fetchList_byAsiakas(
      laskuttajaAsiakasId,
      maksajaAsiakasId,
      token
    );

    if (tarjousListResult.success) _tarjousList = tarjousListResult.data;
    return _tarjousList;
  };
  const doSetTarjousList = useCallback(
    (tarjousList) => {
      setTarjousList(tarjousList);
    },
    [tarjousList]
  );

  const doSetSelectedTarjousId = async (tarjousId) => {
    const a = await tarjous_fetchById(userAsiakas, tarjousId, token);
    if (a.success) setSelectedTarjous(a.data);
  };
  const reloadSelectedTarjous = async () => {
    return await doSetSelectedTarjousId(selectedTarjous.tarjousId);
  };

  // mainTarjous = tarjousList find tarjous.asiakasId = userAsiakas.asiakasId
  const mainTarjous = userAsiakas
    ? tarjousList.find((tarjous) => tarjous.asiakasId === userAsiakas.asiakasId)
    : null;

  return (
    <TarjousContext.Provider
      value={{
        tarjousList,
        isLoaded,
        reloadTarjousList,
        doSetTarjousList,
        mainTarjous,
        tarjous: selectedTarjous,
        setTarjous: setSelectedTarjous,
        setTarjousId: doSetSelectedTarjousId,
        reloadTarjous: reloadSelectedTarjous,
        maksajaAsiakas,
        laskuttajaAsiakas,
      }}>
      {children}
    </TarjousContext.Provider>
  );
};

export const useTarjousData = () => useContext(TarjousContext);

TarjousProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
